import { green, gold, red } from '@ant-design/colors';

const getPercentage = (
  part: number,
  total: number,
  fixedValue?: number,
): number => {
  if (part === 0 || total === 0) return 0;

  const percentage = (part / total) * 100;

  return fixedValue ? Number(percentage?.toFixed(fixedValue)) : percentage;
};

export const getColor = (percentage: number) => {
  if (percentage < 5) {
    return red[4];
  }
  if (percentage < 10) {
    return gold[5];
  }
  if (percentage < 30) {
    return '#00afef';
  }
  return green[5];
};

export default getPercentage;
